export enum projectTab {
  SOURCES = 'sources',
  BOTS = 'bots',
  USERS = 'users',
}
